import axios from 'axios';

class DemoService {
  private baseURL: string;

  constructor() {
    this.baseURL = (import.meta as any).env?.VITE_API_URL || 'http://localhost:3001';
  }

  /**
   * Überprüft ob der Demo-Modus aktiviert ist
   */
  async isDemoModeEnabled(): Promise<boolean> {
    try {
      console.log('Checking demo mode at:', `${this.baseURL}/system/public/demo/status`);
      const response = await axios.get(`${this.baseURL}/system/public/demo/status`);
      console.log('Demo mode response:', response.data);
      return response.data?.data?.demoModeEnabled || false;
    } catch (error) {
      console.error('Error checking demo mode status:', error);
      return false;
    }
  }

  /**
   * Holt Item-Informationen im Demo-Modus
   */
  async getDemoItemInfo(itemId: string): Promise<any> {
    try {
      const response = await axios.get(`${this.baseURL}/system/public/demo/item/${itemId}`);
      return response.data?.data;
    } catch (error) {
      console.error('Error fetching demo item info:', error);
      throw error;
    }
  }

  /**
   * Führt eine Demo-Ausleihe durch
   */
  async createDemoCheckout(itemId: string, quantity: number = 1, notes?: string, sapPlantNumber?: string): Promise<any> {
    try {
      const response = await axios.post(`${this.baseURL}/system/public/demo/checkout/${itemId}`, {
        quantity,
        notes,
        sapPlantNumber
      });
      return response.data?.data;
    } catch (error) {
      console.error('Error creating demo checkout:', error);
      throw error;
    }
  }
}

export const demoService = new DemoService();
export default demoService;
